/**
 * Utilitários para ordenação de listas genéricas
 */

/**
 * Ordena um array de objetos alfabeticamente por um campo específico
 */
export const sortByField = (items, field, order = 'asc') => {
  const sortedItems = [...items].sort((a, b) => {
    let valueA = a[field] || '';
    let valueB = b[field] || '';
    
    valueA = valueA.toString().toLowerCase();
    valueB = valueB.toString().toLowerCase();

    if (order === 'desc') {
      return valueB.localeCompare(valueA, 'pt-BR');
    }
    
    return valueA.localeCompare(valueB, 'pt-BR');
  });
  
  return sortedItems;
};

/**
 * Ordena cursos alfabeticamente pelo nome
 */
export const sortCursos = (cursos, order = 'asc') => {
  return sortByField(cursos, 'curso', order);
};

/**
 * Ordena campis alfabeticamente pelo nome
 */
export const sortCampis = (campis, order = 'asc') => {
  return sortByField(campis, 'campus', order);
};

/**
 * Opções de ordenação padrão
 */
export const SORT_OPTIONS = [
  { value: 'asc', label: 'A → Z' },
  { value: 'desc', label: 'Z → A' }
];

/**
 * Opções de ordenação para Cursos
 */
export const SORT_OPTIONS_CURSOS = [
  { value: 'asc', label: 'Cursos (A-Z)' },
  { value: 'desc', label: 'Cursos (Z-A)' }
];

/**
 * Opções de ordenação para Campis
 */
export const SORT_OPTIONS_CAMPIS = [
  { value: 'asc', label: 'Campis (A-Z)' },
  { value: 'desc', label: 'Campis (Z-A)' }
];

